// @flow
import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import { RouteNames } from 'router';
import Slider from 'react-slick';
import { EventCardMobile } from 'components/molecules/eventCardMobile';
import { useViewport } from 'components/templates/viewportProvider';
import type { Event } from 'types/event';
import { BookTableButton } from 'components/atoms/bookTableButtonMobile';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import './styles.scss';

type Props = {
  events: Array<Event>,
};

const UpcomingEventsMobileCarousel = (props: Props) => {
  const { height } = useViewport();
  const [viewport, setViewport] = useState({
    width: 0,
    height: 0,
  });
  const [showEventsOverlay, setShowEventsOverlay] = useState(false);

  useEffect(() => {
    updateViewport();
    window.addEventListener('resize', updateViewport);
    return () => {
      window.removeEventListener('resize', updateViewport);
    };
  }, []);

  const updateViewport = () => {
    setViewport({
      ...viewport,
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const {
    events,
    overlayData,
    filteredEvents,
    isFiltered,
    activeFilters,
  } = props;
  if (!events || events.length === 0) {
    return null;
  }

  const onEventCardClick = (event: Event) => {
    RouteUtil.setRouteChange(
      props,
      `${RouteNames.musicEvents}/${event.urlSlug}`
    );
  };

  const renderViewAllButton = () => {
    return (
      <BookTableButton
        mode={'dark'}
        onClick={() => setShowEventsOverlay(true)}
        text={'VIEW ALL'}
      />
    );
  };

  const showOverlay = showEventsOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={isFiltered ? filteredEvents : overlayData}
        theme={'light-theme'}
        type={'upcoming-events-mobile'}
        className={'upcoming-events-overlay'}
        onClosePress={() => setShowEventsOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: '',
            breadcrumbLink: '',
          },
        ]}
        activeFilters={activeFilters}
      />
    </OverlayPortal>
  ) : null;

  const settings = {
    className: 'slider',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    verticalSwiping: false,
    swipeToSlide: true,
    touchThreshold: 3000,
  };

  return (
    <div className="theme upcoming-events" style={{ height }}>
      {renderViewAllButton()}
      <Slider {...settings}>
        {(Array.isArray(events) ? events : []).map((event: Event) => {
          const [venue] = Array.isArray(event.venues) ? event.venues.slice(-1) : [];
          return (
            <EventCardMobile
              data={{
                title: event.name,
                subTitle: event.genre,
                imageUrl: event.posterMobile,
                venue,
              }}
              onClick={() => onEventCardClick(event)}
              key={event.id}
              from={'upcoming'}
              ctaText={'EXPLORE'}
            />
          );
        })}
      </Slider>
      {showOverlay}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isFiltered: EventSelector.isUpcomingEventsFiltered(state),
    activeFilters: EventSelector.getActiveUpcomingEventFiltersNames(state),
    filteredEvents: EventSelector.getUpcomingFilteredEvents(state, 'upcoming'),
  };
};
const mapDispatchToProps = dispatch => {
  const { toggleUpcomingEventFilter } = EventActions;
  return bindActionCreators({ toggleUpcomingEventFilter }, dispatch);
};
const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpcomingEventsMobileCarousel);
export default withRouter(connectedComponent);
